import React from "react";
import Blog_56 from "../component/Blog_56";

function Blog_56_container() {
  return <Blog_56 />;
}

export default Blog_56_container;
